import React from 'react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  role: string;
  initials: string;
}
export function TestimonialCard({
  quote,
  name,
  role,
  initials
}: TestimonialCardProps) {
  return <div className="bg-white border border-[rgba(0,0,0,0.04)] rounded-3xl p-8 relative hover:shadow-[0_12px_30px_rgba(0,0,0,0.04)] transition-shadow duration-300" data-id="element-163" data-mp="2kgq043jg9tnk">
      <div className="absolute top-6 right-8 text-[#F1F5F9]" data-id="element-164" data-mp="2u6rsv8mr008t">
        <svg className="w-16 h-16" fill="currentColor" viewBox="0 0 24 24" data-id="element-165" data-mp="2u69kjdmt9vkj">
          <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" data-id="element-166" data-mp="2z4tb5rccnvj8" />
        </svg>
      </div>
      <div className="relative z-10" data-id="element-167" data-mp="19qxzoag1e8vf">
        <div className="flex gap-1 mb-6 text-[#F59E0B]" data-id="element-168" data-mp="19rzhqyvgzvmn">
          {[1, 2, 3, 4, 5].map(star => <svg key={star} className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20" data-id="element-169" data-mp="1drrmt1lnnjn9">
              <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" data-id="element-170" data-mp="htcjftul11r7" />
            </svg>)}
        </div>
        <p className="font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8] mb-8 italic" data-id="element-171" data-mp="10ryofjt7zd0e">
          "{quote}"
        </p>
        <div className="flex items-center gap-4 border-t border-[rgba(0,0,0,0.06)] pt-6" data-id="element-172" data-mp="vt58lkqgn9x2">
          <div className="w-12 h-12 bg-[#EFF6FF] rounded-full flex items-center justify-center text-[#1D4ED8] font-['Montserrat'] font-bold text-[14px]" data-id="element-173" data-mp="qs7vvno7z82y">
            {initials}
          </div>
          <div data-id="element-174" data-mp="3bkjdzo4s6n82">
            <p className="font-['Montserrat'] text-[15px] font-bold text-[#09111F]" data-id="element-175" data-mp="3bl1if81lk7r2">
              {name}
            </p>
            <p className="font-['Inter'] text-[13px] text-[#6B7280]" data-id="element-176" data-mp="36n00iqfwqeh6">{role}</p>
          </div>
        </div>
      </div>
    </div>;
}